import React, { Children } from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  emoji: '🧠',
  title: 'Emotional Awareness',
  description: 'Children learn to name and recognize 12+ emotions through colorful, engaging cards.',
  color: 'bg-peach',
  borderColor: 'border-primary/20'
}, {
  emoji: '🎯',
  title: 'Self-Regulation',
  description: 'Fun breathing exercises and calming strategies they can actually use in the moment.',
  color: 'bg-mint',
  borderColor: 'border-secondary/20'
}, {
  emoji: '❤️',
  title: 'Empathy & Connection',
  description: "Role-playing games that build understanding of others' feelings and improve sibling dynamics.",
  color: 'bg-lavender',
  borderColor: 'border-purple-200'
}];
export function BenefitsSection() {
  return <section className="py-24 bg-cream relative z-0" data-id="element-25">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-27">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-dark mb-6 text-balance" data-id="element-28">
            Simple Activities to Discover Calm, Self-Control, and Empathy{' '}
            <span className="text-secondary" data-id="element-29">— Naturally</span>
          </h2>
          <p className="text-xl text-muted" data-id="element-30">
            No long therapies. No complicated manuals. No screens.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-31">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} whileHover={{
          y: -8
        }} className={`bg-white rounded-3xl p-8 shadow-lg shadow-gray-100/50 border-2 ${benefit.borderColor} transition-all duration-300`} data-id="element-32">
              <div className={`w-16 h-16 rounded-2xl ${benefit.color} flex items-center justify-center text-3xl mb-6`} data-id="element-33">
                {benefit.emoji}
              </div>
              <h3 className="text-2xl font-heading font-bold text-dark mb-4" data-id="element-34">
                {benefit.title}
              </h3>
              <p className="text-muted leading-relaxed text-lg" data-id="element-35">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}